import { twMerge } from "tailwind-merge"

export const RectangleButton = (props) => {
  return (
    <button
      class={twMerge(
        "bg-canvas text-ink font-bold border border-ink-light",
        props.class ?? ""
      )}
      type="button"
      onClick={props.onClick}
    >
      {props.label}
    </button>
  )
}